import * as moment from "moment";
export default function loanCalculator(loan) {
  const { amount, period, rate, isConstant, date } = loan;

  const calculateLoanReducing = (principal, interestRate, numPayments) => {
    // Convert the interest rate from a percentage to a decimal.
    var interestRateDecimal = interestRate / 100;

    // Calculate the monthly payment amount.
    var monthlyPayment =
      (principal *
        interestRateDecimal *
        Math.pow(1 + interestRateDecimal, numPayments)) /
      (Math.pow(1 + interestRateDecimal, numPayments) - 1);

    // Create an array to store the loan amortization schedule.
    var amortizationSchedule = [];

    // Calculate the loan amortization schedule.
    var remainingBalance = principal;
    for (var i = 1; i <= numPayments; i++) {
      var interestPaid = remainingBalance * interestRateDecimal;

      var principalPaid = monthlyPayment - interestPaid;

      remainingBalance -= principalPaid;

      amortizationSchedule.push({
        month: i,
        principal: Math.round(principalPaid / 10) * 10,
        interest: Math.round(interestPaid / 10) * 10,
        balance:
          remainingBalance <= 0 ? 0 : Math.round(remainingBalance / 10) * 10,
        when: moment(date ?? new Date())
          .add(i, "month")
          .format("LL"),
        yourPayment:
          Math.round(principalPaid / 10) * 10 +
          Math.round(interestPaid / 10) * 10,
      });
    }

    // Return the loan amortization schedule.

    return amortizationSchedule;
  };

  const calculateConstantInstallmentLoan = (
    loanAmount,
    interestRate,
    loanTerm
  ) => {
    //PMT = [ r + r / ((1+r)^t -1) ] x P
    interestRate = interestRate / 100;
    let pmt =
      interestRate + interestRate / (Math.pow(1 + interestRate, loanTerm) - 1);
    let amortizationSchedule = [];
    pmt = pmt * loanAmount;
    const interest = loanAmount * interestRate;

    // Calculate the loan amortization schedule.
    var remainingBalance = loanAmount;
    for (var i = 1; i <= loanTerm; i++) {
      var interestPaid = remainingBalance * interestRate;

      var principalPaid = pmt - interestPaid;

      remainingBalance -= principalPaid;

      amortizationSchedule.push({
        month: i,
        principal: Math.round(principalPaid / 10) * 10,
        interest: Math.round(interestPaid / 10) * 10,
        balance:
          remainingBalance <= 0 ? 0 : Math.round(remainingBalance / 10) * 10,
        when: moment(date ?? new Date())
          .add(i, "month")
          //.calendar()
          .format("LL"),
        yourPayment:
          Math.round(principalPaid / 10) * 10 +
          Math.round(interestPaid / 10) * 10,
      });
    }
    //  console.table(amortizationSchedule);
    return amortizationSchedule;
  };

  let results;
  if (isConstant)
    results = calculateConstantInstallmentLoan(amount, rate, period);
  else results = calculateLoanReducing(amount, rate, period);
  return results;
}

export const loan_period = [
  {
    id: 0,
    period: "Select Period",
    value: 0,
  },
  {
    id: 8,
    period: "1 month",
    value: 1,
  },

  {
    id: 1,
    period: "6 months",
    value: 6,
  },
  {
    id: 2,
    period: "12 months",
    value: 12,
  },
  {
    id: 3,
    period: "18 months",
    value: 18,
  },
  {
    id: 4,
    period: "24 months",
    value: 24,
  },
  {
    id: 5,
    period: "36 months",
    value: 36,
  },
  {
    id: 6,
    period: "48 months",
    value: 48,
  },
  {
    id: 7,
    period: "96 months",
    value: 96,
  },
];

export const loan_details = [
  { id: 0, loan_type: "Select loan type", max_period: 0 },
  {
    id: 1,
    loan_type: "Normal Loan",
    interest_rate: 1,
    max_period: 48,
  },
  {
    id: 2,
    loan_type: "Boresha Loan",
    interest_rate: 1,
    max_period: 36,
  },
  {
    id: 3,
    loan_type: "Emergency Loan",
    interest_rate: 1,
    max_period: 12,
  },
  {
    id: 4,
    loan_type: "Jijenge 25",
    interest_rate: 1.25,
    max_period: 96,
  },
  {
    id: 5,
    loan_type: "Jijenge 19",
    interest_rate: 1.25,
    max_period: 96,
  },
  {
    id: 6,
    loan_type: "Fosa Pride Loan",
    interest_rate: 1.5,
    max_period: 48,
  },
  {
    id: 7,
    loan_type: "Jambo Fosa",
    interest_rate: 1,
    max_period: 24,
  },
  {
    id: 8,
    loan_type: "Imara Loan",
    interest_rate: 1.25,
    max_period: 96,
  },
  {
    id: 9,
    loan_type: "Instant Loan",
    interest_rate: 1,
    max_period: 24,
  },
  {
    id: 10,
    loan_type: "School Fees loan",
    interest_rate: 1,
    max_period: 18,
  },
  {
    id: 11,
    loan_type: "Salary Advance",
    interest_rate: 15,
    max_period: 12,
  },
  {
    id: 12,
    loan_type: "Salary in Advance",
    interest_rate: 10,
    max_period: 1,
  },
  { id: 13, loan_type: "NORMAL PLUS", max_period: 96, interest_rate: 1 },
];
